const mainline = {
  "comparisonTooLarge": "比較資料が1回の処理上限を超えています。資料を分けて保存し、再実行してください。保存済みの行は保持しています。",
  "extractionMode": "変更点の抽出モード",
  "focused": "主要な変更点（最大10件）",
  "exhaustive": "全件（網羅抽出）",
  "extractionModeHint": "旧新仕様の比較に適用します。設定を保存してもAIは実行されません。10件は1回のAI提示の上限で、手入力や保存総数の上限ではありません。",
  "exhaustiveHint": "全件抽出は時間がかかります。選択資料の取得できた範囲を対象とし、実際の変更をすべて検知した保証ではありません。上限に達した場合は資料を分けて再実行してください。",
  "exhaustiveWorking": "処理中… 全件抽出は時間がかかる場合があります。保存済みの行は保持しています。",
  "savedExtractionMode": "次回の抽出設定",
  "extractAdditional": "全件で追加抽出",
  "lastExtraction": "前回の抽出：{{mode}}・候補{{count}}件（旧{{old}}文字／新{{new}}文字）。保存・採用件数とは別です。",
  "extractionCompleted": "抽出完了：{{mode}}・候補{{count}}件（まだ保存行には反映していません）",
  "extractionReviewHint": "重複は追加しません。似た既存行がある候補は、見送り・別の行として追加・既存行を更新から選べます。更新を選んだ行以外の手入力や判断は保持します。",
  "comparisonCharacters": "比較した入力：旧{{old}}文字／新{{new}}文字",
  "match_new": "新規候補",
  "match_duplicate": "保存済みの内容・根拠と同じ候補（重複追加なし）",
  "match_possible_match": "似た既存行があります。内容・判断を比較してください。",
  "candidateAction": "この候補の扱い",
  "keepExisting": "追加・更新を見送る（既存を保持）",
  "addCandidate": "新しい行として追加",
  "updateCandidate": "選んだ既存行を更新",

  "temporarilyUnavailable": "一時的に処理できません。入力は保持しています。少し待ってから同じ操作を再試行してください。",
  "saveInputsFirst": "資料・条件に未保存の変更があります。先に保存してからレビュー・AI実行・出力を進めてください。",
  "applyReason": "適用理由（空欄の場合は候補の理由を記録）",
  "comparisonScope": "今回の比較は旧新仕様を使用しました。選択した参考資料・追加条件は、下流生成と再考で使用します。",
  "documentNotReady": "文書のテキストをまだ読み込めません。抽出完了を待つか、貼付テキストへ切り替えてください。",
  "textReady": "本文読込済み",
  "textNotReady": "本文未読込・貼付入力も利用できます",
  "titleMatch": "候補理由：資料名が検索語に一致",
  "recentCandidate": "候補理由：テナント内の最近更新した資料",
  "confirmScores": "保存済みのS/O/Dを確認し、この判断と一緒に評価を確定する",
  "blocker_design_change_missing": "変更点が未登録です",
  "blocker_design_change_review": "変更点のレビューが必要です",
  "blocker_failure_mode_coverage": "採用した変更点に故障モードが必要です",
  "blocker_failure_mode_review": "故障モードのレビューが必要です",
  "blocker_failure_mode_structure": "故障内容・原因・影響を記入してください",
  "blocker_countermeasure_review": "対策のレビューが必要です",
  "blocker_countermeasure_reason": "対策不要の理由を記入してください",
  "blocker_countermeasure_coverage": "対策要否の判断・必要な対策の採用が必要です",
  "blocker_countermeasure_mechanism": "対策の対象原因・作用を記入してください",
  "blocker_countermeasure_verification": "検証方法・合格基準を記入してください",
  "blocker_needs_recheck": "入力や親が変わったため再確認が必要です",
  "blocker_unknown_conditions": "未確認条件が残っています",
  "blocker_score_review": "S/O/Dの評価が未確認です",
  "blocker_input_condition": "材料・寸法・使用条件または参照資料に未確認があります",
  "blocker_reference_unavailable": "選択した資料に未読込の範囲があります",
  "open": "入力・レビューを進める",
  "normalView": "通常の結果表示へ",
  "progress": "資料・条件 → 変更点 → 故障モード → 対策 → 確認・出力",
  "inputs": "資料・条件",
  "target": "対象部品・機能",
  "pattern": "入力方法",
  "old_new_documents": "旧仕様＋新仕様",
  "old_requirements": "旧仕様＋新しい要件",
  "change_report": "変更・DRレポート",
  "manual": "直接入力",
  "import": "取込",
  "ai": "AI候補",
  "legacy": "従来データ（由来未記録）",
  "old_text": "旧仕様",
  "new_text": "新仕様",
  "report_text": "レポート本文",
  "requirements": "新しい要件",
  "requirementsHint": "AIが要件から変更案を作成します。確定した仕様差分とは区別して確認してください。",
  "registeredDocument": "登録文書（候補検索から選択）",
  "pastedText": "貼付テキストを使う",
  "references": "参照候補を検索・選択",
  "searchQuery": "文書名の検索語",
  "search": "検索・再検索",
  "searchFailed": "候補取得に失敗しました。再検索してください。",
  "searchScope": "このテナントの文書名を検索します。名称・更新情報を確認して参照対象を選択してください。",
  "selectedCount": "参照対象 {{count}}件",
  "characters": "文字",
  "more": "追加読込",
  "material": "材料（不明なら空欄）",
  "dimensions": "寸法（不明なら空欄）",
  "operating_conditions": "使用条件（不明なら空欄）",
  "constraints": "制約・補足",
  "conditionsHint": "材料・寸法・使用条件の空欄は未確認として保持します。対象外の場合は、その理由を記入してください。",
  "saveInputs": "資料・条件を保存（AI実行なし）",
  "actualScope": "保存した参照範囲",
  "partial": "一部のみ参照",
  "evidence": "根拠・調査メモ",
  "sourceKind": "情報の種類",
  "input_fact": "入力事実",
  "internal_document": "社内資料",
  "public_information": "公開情報メモ",
  "ai_assumption": "AI仮定",
  "sourceTitle": "資料名・根拠名",
  "quote": "引用箇所・内容",
  "retrievedOn": "取得日",
  "applicability": "適用条件",
  "addEvidence": "根拠欄に追加",
  "remove": "除外",
  "webHint": "Web調査メモの取込です。自動Web検索は実行しません。入力欄の変更は保存で確定します。",
  "design_change": "変更点",
  "failure_mode": "故障モード",
  "countermeasure": "対策",
  "category": "カテゴリ",
  "item_name": "対象部品・機能",
  "old_specification": "旧状態",
  "new_specification": "新状態・要件",
  "change_description": "変更内容・理由",
  "failure_description": "故障の現象",
  "failure_cause": "原因",
  "failure_effect": "影響",
  "severity_score": "S（重大度、任意）",
  "occurrence_score": "O（発生度、任意）",
  "detection_score": "D（検出度、任意）",
  "countermeasure_requirement": "対策の要否",
  "countermeasure_not_required_reason": "対策不要の理由",
  "pending": "未判断",
  "required": "必要",
  "not_required": "不要",
  "description": "対策内容",
  "countermeasure_type": "対策種別",
  "prevention": "予防",
  "detection": "検出",
  "mitigation": "緩和",
  "target_cause": "対象原因",
  "mechanism": "作用機序",
  "verification_method": "検証方法",
  "acceptance_criteria": "合格基準",
  "unknown": "未確認条件・仮定（1行に1件）",
  "scoreHint": "S/O/Dは任意です。保存だけでは採点確認やRPNの確定になりません。",
  "parent": "親項目",
  "selectParent": "親を選択してください",
  "importParent": "今回作成する親",
  "add": "手入力で追加",
  "save": "編集を保存",
  "closeEditor": "編集欄を閉じる",
  "editReview": "編集・レビュー",
  "generate": "AI候補を作成",
  "reason": "判断・変更の理由",
  "reviewSavedHint": "採用・保留・却下・AI再考は保存済みの内容に対して行います。編集中の内容は先に保存してください。",
  "reconfirm": "親・条件の変更による影響を再確認した",
  "accepted": "採用",
  "modified": "修正採用",
  "deferred": "保留",
  "rejected": "却下",
  "ai_candidate": "未レビュー",
  "needs_info": "情報不足",
  "superseded": "旧版",
  "recheck": "要再確認",
  "revisionInstruction": "AIへの再考指示",
  "reconsider": "AIに再考を依頼",
  "execution": "対策の実行",
  "verification": "対策の検証",
  "not_started": "未実行",
  "completed": "実行完了",
  "not_verified": "未検証",
  "verified": "検証完了",
  "owner": "担当者（任意）",
  "dueDate": "期限（任意）",
  "counts": "全 {{total}}件 / フィルタ {{filtered}}件",
  "filter": "表示範囲",
  "all": "全件",
  "pageSize": "1ページ",
  "previous": "前へ",
  "next": "次へ",
  "proposedChange": "要件からの変更案",
  "unconfirmed": "未確認",
  "preview": "未適用の候補プレビュー",
  "stalePreview": "入力・判断が更新されています。この候補は適用できません。破棄して作り直してください。",
  "before": "現在",
  "after": "変更案",
  "noneAdded": "追加なし",
  "confirmParents": "候補の内容と親子関係を確認した",
  "orphanHint": "親のない行があります。親を選択してください。親を新しく作る場合は候補を破棄し、手入力で親を保存してから再取込してください。",
  "inputOnly": "入力した資料・条件のみ",
  "apply": "選択した差分・候補を適用",
  "discard": "候補を破棄",
  "importPreview": "レポート取込候補を確認",
  "loadFailed": "保存データを取得できませんでした。履歴から再度開いてください。",
  "conflict": "別の編集が保存されています。入力欄は保持しました。「再取得」で最新状態を確認してから再操作してください。",
  "validationFailed": "入力内容・親子関係・再確認のチェックを確認してください。登録文書は抽出済みテキストが必要です。入力は保持しています。",
  "commandFailed": "処理に失敗しました。保存済み入力は保持されています。同じ操作を再試行できます。",
  "readOnly": "本線編集の公開設定はOFFです。保存済み結果は参照できます。",
  "working": "処理中…",
  "reload": "再取得して再操作",
  "retry": "同じ操作を再試行",
  "export": "確認・Excel出力",
  "draft": "ドラフト",
  "content_reviewed": "内容レビュー済み",
  "scored": "採点確認済み",
  "blockers": "未解決 {{count}}件",
  "exportScope": "出力範囲",
  "acceptedScope": "採用・修正採用済み",
  "exportHint": "Excelは表示ページや表示フィルタに制限されません。未確認・要再確認が残る場合はドラフトとして出力します。",
  "export_draft": "ドラフトExcel",
  "export_reviewed": "内容レビュー済みExcel",
  "export_scored": "採点済みExcel",
  "history": "保存・判断履歴"
};
export default mainline;
